import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, SharedClientCentricContentShareAssignmentDTO, SharedClientNetworkAccessDTO } from 'src/app/services/api/api';
import { SbLocalDateTime } from 'src/app/services/api/api-date-time';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { DateTime } from 'luxon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'sb-page-device-details-network-access',
  templateUrl: './device-details-network-access.component.html',
  styleUrls: ['./device-details-network-access.component.scss'],
  standalone: false,
})
export class DeviceDetailsNetworkAccessComponent implements OnInit {
  deviceId: number;
  networkAccesses: SharedClientNetworkAccessDTO[];

  loading: boolean = true;

  debounceTimer: ReturnType<typeof setTimeout> = null;

  // tslint:disable-next-line:variable-name
  _from?: SbLocalDateTime;
  get from(): SbLocalDateTime {
    return this._from;
  }

  set from(val) {
    this._from = val;
  }

  // tslint:disable-next-line:variable-name
  _till?: SbLocalDateTime;
  get till(): SbLocalDateTime {
    return this._till;
  }

  set till(val) {
    this._till = val;
  }

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.deviceId = +params.deviceID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    // const defaultTime: SbLocalDateTime = new SbLocalDateTime(DateTime.now());
    this.api
      .ss_nm_Network_retrieveNetworkAccess({
        device: [this.deviceId],
        // from: this.from ?? defaultTime,
        // till: this.till ?? defaultTime,
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (e: SharedClientNetworkAccessDTO[]) => {
          this.networkAccesses = e;
        },
        error: error => {
          if (!error.status || !(+error.status === 403 || +error.status === 404)) {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }

  handleDateChangeFrom(date: SbLocalDateTime) {
    this.from = date;
  }

  handleDateChangeTill(date: SbLocalDateTime) {
    this.till = date;
  }
}
